<template>
  <form class="flex flex-wrap w-full" @submit.prevent="submit">
    <form-group class="p-0 mb-4" field="product" label="Produit">
      <select-product :config="selectProductConfig" v-model="product">
        <template slot="option" slot-scope="{option}">
          <span class="inline-flex items-center justify-between w-full">
            <span class="">{{ option.name }}</span>
            <vue-tag :class="stockClass(option.stock_status)" icon="cupcake-solid" v-if="option.stock !== null">
              {{ option.stock }}
            </vue-tag>
          </span>
        </template>
      </select-product>
    </form-group>

    <form-group class="md:w-2/3 p-0 mb-4" field="quantity" label="Quantité">
      <vue-input-number v-model="form.quantity" :min="1" :disabled="isFormDisabled"/>
    </form-group>

    <form-group class="p-0 mb-4" field="note" label="note" >
      <vue-input v-model="form.note" :disabled="isFormDisabled"/>
    </form-group>

    <div class="p-0 border-t border-gray-lighter pt-4 flex w-full justify-end flex-col-reverse md:flex-row">
      <vue-button @click="$modal.close('cart-product')" class="btn btn-gray btn-outline w-full md:w-auto md:mr-2">Fermer</vue-button>
      <vue-button type="submit"
                  class="btn btn-primary w-full md:w-auto mb-2 md:mb-0"
                  :status="status"
                  :disabled="isFormDisabled">{{ isAddCartProductForm ? 'Ajouter' : 'Modifier' }}
      </vue-button>
    </div>
  </form>
</template>

<script>
/* globals route */

import Form from 'form-backend-validation';
import FormGroup from '../FormGroup.vue';
import SelectProduct from '../products/ProductSelect.vue';
import ErrorHandler from '../../core/ErrorHandler';

export default {
  props: {
    model: {
      type: Object,
      required: true,
    },
  },

  components: { SelectProduct, FormGroup },

  data() {
    return {
      product: '',
      status: null,
      form: new Form(
        {
          quantity: 1,
          note: '',
        },
        { resetOnSuccess: false },
      ),
    };
  },

  created() {
    if (this.isEditCartProductForm) {
      this.form.populate(this.model);
      this.product = this.model;
    }
  },

  computed: {
    isFormDisabled() {
      return this.form.processing;
    },

    isAddCartProductForm() {
      return Object.keys(this.model).includes('customer');
    },

    isEditCartProductForm() {
      return !this.isAddCartProductForm;
    },

    routeUrl() {
      return this.isAddCartProductForm
        ? route('api.cartsProducts.store', [this.model.id, this.product.id])
        : route('api.cartsProducts.update', this.model.cart_product_id);
    },

    method() {
      return this.isAddCartProductForm ? 'post' : 'patch';
    },

    selectProductConfig() {
      return {
        customLabel({ name, stock }) {
          return `${name}${stock !== null ? ` (${stock})` : ''}`;
        },
        disabled: this.isEditCartProductForm || this.isFormDisabled,
      };
    },
  },

  methods: {
    submit() {
      if (!this.product) {
        this.errorMissingProduct();
        return;
      }
      this.status = 'loading';
      this.form[this.method](this.routeUrl)
        .then(({ data }) => {
          this.onSuccess();
          this.$emit('updated', data);
        })
        .catch((error) => {
          new ErrorHandler(error).dispatch();
          this.onFail();
        });
    },

    onSuccess() {
      this.status = 'succeeded';
      setTimeout(() => {
        this.status = null;
        if (this.isEditCartProductForm) {
          this.$modal.close('cart-product');
          return;
        }
        this.product = '';
        this.form.reset();
      }, 1500);
    },

    onFail() {
      this.status = 'failed';
      setTimeout(() => {
        this.status = null;
      }, 1500);
    },

    errorMissingProduct() {
      this.$notify({
        type: 'error',
        title: 'Erreur',
        text: 'Vous devez sélectionner un produit.',
      });
    },

    stockClass(status) {
      switch (status) {
        case null:
          return 'bg-gray-lightest text-gray';
        case 'very-low':
          return 'bg-red-lightest text-red-light';
        case 'low':
          return 'bg-orange-lightest text-orange';
        case 'normal':
          return 'bg-green-lightest text-green-light';
        default:
          return '';
      }
    },
  },
};
</script>